// eslint-disable-next-line no-shadow
export var SLOT_CONFIRMATION_STATE;
(function (SLOT_CONFIRMATION_STATE) {
    SLOT_CONFIRMATION_STATE["IDLE"] = "idle";
    SLOT_CONFIRMATION_STATE["LOADING"] = "loading";
    SLOT_CONFIRMATION_STATE["SUCCESS"] = "success";
    SLOT_CONFIRMATION_STATE["ERROR"] = "error";
})(SLOT_CONFIRMATION_STATE || (SLOT_CONFIRMATION_STATE = {}));
